import React from 'react';
import {useTranslation} from 'react-i18next';
import {SpecificationViewData} from '../../../models/specificationViewer';

type SpecHeaderProps = {
    spec: SpecificationViewData;
}

const SpecHeader: React.FC<SpecHeaderProps> = ({spec}) => {
    const {t} = useTranslation();

    return (
        <div className="spec-header">
            <div className="spec-number-row">
                <div className="spec-number">{spec.number}</div>
                <div className="spec-status">{t('specificationViewer.status.' + spec.status.toLowerCase())}</div>
            </div>
            <div className="spec-component">{spec.componentName}</div>
            {spec.componentNumbers.length > 0 &&
                <div className="spec-component-numbers">
                    {t('specificationViewer.componentNumbers')}: {spec.componentNumbers.map(cn => cn.number).join(', ')}
                </div>
            }
            {spec.componentUsage &&
                <div className="spec-description">
                    <strong>{t('specificationViewer.componentUsage')}:</strong> {spec.componentUsage}
                </div>
            }
            {spec.problemDescription &&
                <div className="spec-description">
                    <strong>{t('specificationViewer.problemDescription')}:</strong> {spec.problemDescription}
                </div>
            }
            {spec.defectDescription &&
                <div className="spec-description">
                    <strong>{t('specificationViewer.defectDescription')}:</strong> {spec.defectDescription}
                </div>
            }
        </div>
    );
};

export default SpecHeader;
